module.exports = __webpack_public_path__ + "img/bannerLabel1Red.59f71122.png";